import React from 'react';
import { Box, Typography } from '@mui/material';
import { Confetti, PrimaryButton, ScreenShell, ScreenTitle, SecondaryButton, tokens } from '../parts';
import { GoalFlowScreenProps } from './types';

/** "Activity added!" / "Activity updated!" — shown after every add or edit. */
export const CelebrateScreen: React.FC<GoalFlowScreenProps> = ({ goalFlow }) => (
  <ScreenShell
    overlay={<Confetti />}
    footer={
      <>
        {goalFlow.canAddMore && <PrimaryButton onClick={goalFlow.addAnother}>Add Another Activity</PrimaryButton>}
        <SecondaryButton onClick={goalFlow.review}>Review SMART Goal</SecondaryButton>
      </>
    }
  >
    <Box
      sx={{
        minHeight: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 3,
        px: 1.5,
        pt: 8,
        textAlign: 'center',
      }}
    >
      <Box
        component="img"
        src="/assets/svg/sloth-celebration.svg"
        alt=""
        aria-hidden
        sx={{ width: 140, height: 140 }}
      />
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <ScreenTitle large>{goalFlow.celebrateUpdated ? 'Activity updated!' : 'Activity added!'}</ScreenTitle>
        <Typography sx={{ fontSize: '15px', color: tokens.textPrimary, lineHeight: 1.6 }}>
          {goalFlow.celebrateUpdated
            ? 'Your change has been saved to your goal.'
            : `Keep going — ${goalFlow.activityCount} ${goalFlow.activityCount === 1 ? 'activity is' : 'activities are'} in your goal.`}
        </Typography>
      </Box>
    </Box>
  </ScreenShell>
);
